'use client';

import {
  Link as ChakraNextLink,
  LinkProps as ChakraNextLinkProps,
} from '@chakra-ui/next-js';
import { Link as ChakraLink } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { ComponentProps, useMemo } from 'react';

const MotionChakraNextLink = motion.create(ChakraNextLink);
const MotionChakraLink = motion.create(ChakraLink);

type MotionChakraLinkProps = ComponentProps<typeof MotionChakraLink>;

type Props = MotionChakraLinkProps &
  ChakraNextLinkProps & {
    isExternal?: boolean;
    isInteractivityHighlightEnabled?: boolean;
  };

export type LinkProps = Props;

export const Link = (props: Props) => {
  const {
    isExternal = false,
    isInteractivityHighlightEnabled = true,
    ...rest
  } = props;

  const LinkComponent = isExternal ? MotionChakraLink : MotionChakraNextLink;

  const animation = useMemo(() => {
    if (!isInteractivityHighlightEnabled) return {};

    return {
      whileHover: { scale: 1.05 },
      whileTap: { scale: 0.95 },
    };
  }, [isInteractivityHighlightEnabled]);

  return (
    <LinkComponent
      _hover={
        isInteractivityHighlightEnabled ? { color: 'dynamic.accent' } : {}
      }
      {...animation}
      {...rest}
    />
  );
};
